import React, {useState} from "react";


const EventPressReleaseCampaign = ({ eventsItems, activeIndex, setActiveIndex }) => {
    const [activeEventIndex, setActiveEventIndex] = useState(1);
    const [loading, setLoading] = useState(false);

    const renderEventDetails = (event, index, handler) => {
        return (
            <div
                className={`events_container__item`}
                key={index}
                onClick={handler}
            >
                <img
                    src={event.banner_image}
                    alt="event"
                    width="76"
                    height="46"
                />
                <div>
                    <h4 className="text-ellipse">{event.name}</h4>
                    <span>{event.event_address}</span> |{" "}
                    <span className="ml-1">{event?.start_date}</span>
                </div>
            </div>
        );
    }

    const renderConfirmation = () => {
        return(
            <div className="marketing__content cts-container">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <h2 className="feature-heading">Event Press Release Campaign</h2>
                    <div className="d-flex align-items-center ml-auto">
                        <button
                            className="review-button"
                            onClick={() => {
                                setLoading(true);
                                window.location = `/api/marketing/${eventsItems[activeEventIndex].id}/press_release_ai`;
                            }}
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Review/Submit"}
                        </button>
                    </div>
                </div>

                <div className="marketing__content__events">
                    <div className="marketing__content__events__sidebar">
                        <div className="event-header">
                            <h2 className="title">Selected Event:</h2>
                        </div>
                        <div className="events_container">
                            {renderEventDetails(eventsItems[activeEventIndex], activeEventIndex, null)}
                        </div>
                    </div>
                </div>

                <p>Generate a press release for this event by clicking "Review/Submit" to get started.</p>
            </div>
        );
    }

    if (activeIndex === 2) {
        return renderConfirmation();
    }

    return (
        <div className="marketing__content cts-container">
            <h2 className="feature-heading text-capitalize text-center">Event Press Release Campaign</h2>
            <div className="marketing__content__events justify-content-center">
                <div className="marketing__content__events__sidebar w-75">
                    {(eventsItems.length > 0 ) ? (
                        <div className="event-header">
                            <h2 className="title">Select One Event</h2>
                        </div>
                    ) : (
                        <div className="event-header" style={{ justifyContent: 'center' }}>
                            <h2 className="title text-center">No upcoming events to select.</h2>
                            <a href="/events/new" className="btn btn-primary">
                                Click here to create a new event
                            </a>
                        </div>
                    )}

                    <div className="events_container">
                        {eventsItems.map((event, index) => (
                            renderEventDetails(event, index, () => {
                                setActiveEventIndex(index);
                                setActiveIndex(2);
                            })
                        ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default EventPressReleaseCampaign;
